<template>
  <v-container>
    <v-form ref="form" v-model="isValid">
    <v-row dense>
      <v-col cols="12" sm="6">
        <v-select
          v-model="entity.objectType"
          label="Тип объекта *"
          :items="objTypes"
          :rules="[v => !!v || 'Выберите тип объекта']"
          filled
        ></v-select>
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="entity.addressPublic"
          label="Адрес дома (или название ЖК) *"
          :rules="[v => !!v || 'Введите адрес объекта']"
          filled
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="entity.floor"
          label="Номер этажа *"
          :rules="[v => !!v || 'Введите этаж.', v => isNumber(v) || 'Этаж должен быть числом']"
          filled
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="entity.height"
          label="Высота потолков (м) *"
          :rules="[v => !!v || 'Введите высоту потолков.', v => isNumber(v) || 'Высота должна быть числом']"
          filled
        ></v-text-field>
      </v-col>
      <v-col cols="12" class="d-flex">
        <v-spacer></v-spacer>
        <v-switch
          v-model="entity.isElevatorEnable"
          :label="`Наличие лифта: ${entity.isElevatorEnable ? 'да' : 'нет'}`"
        ></v-switch>
        <v-spacer></v-spacer>
      </v-col>
    </v-row>
    <div>
      <v-card>
        <v-card-title>
          <span>Комнаты</span>
          <v-spacer></v-spacer>
          <v-alert color="green" dense outlined small>
            Общая площадь: {{ roomsSquare }} м²
          </v-alert>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :items="entity.rooms"
            :headers="roomsHeader"
            hide-default-footer
          >
            <template v-slot:[`item.actions`]="{ item }">
              <room-card
                :value="item"
                :defaultHeight="entity.height"
                @save="saveRoom($event)"
                :key="String(item._id)"
                :rooms="entity.rooms"
              ></room-card>
              <delete-button
                :key="'d' + item._id"
                :id="item._id"
                objName="комнату"
                :deleteFunc="deleteRoom"
              >
                Название комнаты: {{ item.name }}
              </delete-button>
            </template>
          </v-data-table>
          <div class="d-flex mt-3">
            <v-spacer></v-spacer>
            <room-card
              :defaultHeight="entity.height"
              @save="saveRoom($event)"
              :rooms="entity.rooms"
            ></room-card>
            <v-spacer></v-spacer>
          </div>
        </v-card-text>
      </v-card>
    </div>
    <div class="mt-7">
      <v-card>
        <v-card-title>Планировка и дизайн-проект</v-card-title>
        <v-card-text>
          <files-table
            v-model="entity.files"
            label="Приложенные файлы"
          ></files-table>
        </v-card-text>
      </v-card>
    </div>
    </v-form>
    <div class="mt-7 d-flex">
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="save()">Продолжить</v-btn>
    </div>
  </v-container>
</template>

<script>
import RoomCard from './constructor_object/ConstructorRoomCard';
const MongoID = require('mongoose').Types.ObjectId;

export default {
  components: {
    'room-card': RoomCard,
  },

  props: {
    value: Object,
  },

  data() {
    return {
      isValid: false,
      entity: this.value ? this.value : this.getDefaultObj(),
      objTypes: ['Квартира', 'Частный дом', 'Коммерческое помещение'],
      roomsHeader: [
        {
          text: 'Название',
          value: 'name'
        },
        {
          text: 'Площадь',
          value: 'finalParams.floor_square'
        },
        {
          text: 'Действия',
          value: 'actions'
        }
      ]
    }
  },

  methods: {
    getDefaultObj() {
      return {
        objectType: '',
        addressPublic: '',
        floor: null,
        isElevatorEnable: true,
        rooms: [],
        files: [],
        height: 3
      }
    },
    saveRoom(room) {
      if (room._id) {
        let index = this.entity.rooms.findIndex(x => x._id == room._id);
        this.entity.rooms.splice(index, 1, room);
      } else {
        room._id = String(new MongoID());
        this.entity.rooms.push(room);
      }
      this.$store.dispatch('showMessage', 'Данные по комнате сохранены.')
    },
    async deleteRoom(id) {
      let index = this.entity.rooms.findIndex(x => x._id == id);
      this.entity.rooms.splice(index, 1);
      return {
        message: 'Комната успешно удалена'
      }
    },
    save() {
      this.$refs.form.validate();
      if (this.isValid) {
        if (this.roomsSquare == 0) this.$store.dispatch('showMessage', 'Укажите хотя бы одну комнату.')
        else this.$emit('save', this.entity);
      }
    },
  },

  computed: {
    roomsSquare() {
      return this.entity.rooms.reduce((sum, cur) => sum + Number(cur.finalParams.floor_square), 0).toFixed(2);
    },
    
  }
}
</script>